<template>
  <div
    :style="{ left: `${-12 * index}px` }"
    class="member-icon"
  >
    <div class="member-avatar">
      {{ memberFirstNameLetter }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "MemberInfo",
    props: {
      member: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    computed: {
      memberFirstNameLetter() {
        return this.member.fname.slice(0, 1).toUpperCase();
      },
    },
  };
</script>

<style lang="scss" scoped>
.member-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 2px solid white;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.06);
}

.member-avatar {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4D84FF 0%, #6B9AFF 100%);
  border-radius: 50%;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: white;
}

@media (min-width: 768px) {
  .member-icon {
    width: 40px;
    height: 40px;
  }

  .member-avatar {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
}
</style>
